import { Subscription } from 'rxjs';
import { FamilyService } from './../../services/family/family.service';
import { Router } from '@angular/router';
import { PdvService } from '@app/services/pdv/pdv.service';
import { Component } from '@angular/core';
import { OrdersService } from '@app/services/order/orders.service';
@Component({
    selector: 'home',
    templateUrl: 'home.component.html',
    styleUrls: ['home.component.scss']
})
export class HomeComponent {
    authorizedCities: any[] = [];
    ourAppEvent;
    families: any[] = [];
    menucategories: any[] = [];
    displayMenu: boolean = false;
    sub: Subscription;
    pdv: any = {};
    enablePayement = false;
    subs: Subscription;
    constructor(private pdvService: PdvService,
        private router: Router,
        private familyService: FamilyService,
        private orderService: OrdersService
    ) {
        this.orderService.ourAppEvent.subscribe(
            (data) => {
                this.ourAppEvent = data;
            }
        )
        this.getFamiliesOfCarte();
        this.getMenuCategoriesOfCarte();
        this.sub = this.pdvService.pdv.subscribe(
            (pdv) => {
                this.pdv = pdv;
            }
        )
        this.subs = this.orderService.enablePayement.subscribe(
            (enablePayement) => {
                this.enablePayement = enablePayement
            }
        );
    }


    ngOnInit() {
        this.pdvService.getAuthorizedCities().subscribe(
            (authorizedCities: any[]) => {
                this.authorizedCities = authorizedCities;
            }
        )
    }
    ngOnDestroy() {
        this.sub.unsubscribe();
        this.subs.unsubscribe();
    }
    getFamiliesOfCarte() {
        this.familyService.families.subscribe(
            (families: any[]) => {
                this.families = families
            }
        )
    }
    getMenuCategoriesOfCarte() {
        this.familyService.menucategories.subscribe(
            (menucategories: any[]) => {
                this.menucategories = menucategories;
            }
        )
    }
    goToCarte() {
        this.familyService.families.subscribe(
            (families: any[]) => {
                this.router.navigate(['/carte/famille/' + families[0].slug])
            }
        )
    }
}
